
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/discounts/[brand]/[slug]",
      function () {
        return require("private-next-pages/discounts/[brand]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/discounts/[brand]/[slug]"])
      });
    }
  